import mexp from "math-expression-evaluator";

export function findCurrentStep(step) {
  if (step != null) {
    if (step.result != null) {
      if (step.outcomes) {
        return findCurrentStep(
          step.outcomes[step.result.outcome ? step.result.outcome : 0]
        );
      } else {
        return null;
      }
    } else {
      return step.title ? step : null;
    }
  } else {
    return null;
  }
}

export function findPreviousStep(step, lastStep = null) {
  if (step != null && step.result != null) {
    if (step.outcomes) {
      return findPreviousStep(
        step.outcomes[step.result.outcome ? step.result.outcome : 0],
        step
      );
    } else {
      return step;
    }
  } else {
    return lastStep;
  }
}

export function findCurrentStepIndex(step) {
  let currentStepIndex = 1;

  if (step != null && step.result != null) {
    if (step.outcomes) {
      currentStepIndex += findCurrentStepIndex(
        step.outcomes[step.result.outcome ? step.result.outcome : 0]
      );
    }
  }

  return currentStepIndex;
}

export function getTotalSteps(step) {
  let totalSteps = 0;

  if (step != null) {
    totalSteps = 1;
  }

  if (step != null && step.outcomes) {
    let outcomeIndex = step.result
      ? step.result.outcome
        ? step.result.outcome
        : 0
      : 0;
    totalSteps += getTotalSteps(step.outcomes[outcomeIndex]);
  }

  return totalSteps;
}

export function mapCompleteSteps(step, func) {
  let mappedArray = [];

  if (step != null && step.result) {
    let res = func(step);
    if (res != null) {
      mappedArray.push(func(step));
    }

    if (step.outcomes) {
      let outcomeIndex = step.result
        ? step.result.outcome
          ? step.result.outcome
          : 0
        : 0;

      mappedArray.push(mapCompleteSteps(step.outcomes[outcomeIndex], func));
    }
  }

  return mappedArray.flat();
}

export function getAllResultsArray(step, index = 1) {
  let allResults = [];

  if (step != null && step.result) {
    allResults.push({
      title: step.title,
      name: step.name,
      result: step.result
    });

    if (step.outcomes) {
      let outcomeIndex = step.result
        ? step.result.outcome
          ? step.result.outcome
          : 0
        : 0;

      index++;

      allResults.push(getAllResultsArray(step.outcomes[outcomeIndex], index));
    }
  }

  return allResults.flat();
}

export function getAllResults(
  step,
  index = 1,
  titleFieldToReturn = "title",
  valueFieldToReturn = "title"
) {
  let allResults = {};

  if (step != null && step.result) {
    let result = step.result[valueFieldToReturn];

    if (Array.isArray(step.result)) {
      result = step.result.map(res => res[valueFieldToReturn]);
    }

    allResults = {
      ...{
        ["q" + index]: step[titleFieldToReturn],
        ["a" + index]: result
      }
    };

    if (step.outcomes) {
      let outcomeIndex = step.result
        ? step.result.outcome
          ? step.result.outcome
          : 0
        : 0;

      index++;

      allResults = {
        ...allResults,
        ...getAllResults(
          step.outcomes[outcomeIndex],
          index,
          titleFieldToReturn,
          valueFieldToReturn
        )
      };
    }
  }

  return allResults;
}

export function parseAndCalculatePrice(step, calculation = "") {
  if (step.result == null) {
    return "";
  }

  let reg = /\{([0-9]+)}/g;
  let matches = (calculation || "").match(reg) || [];

  matches.forEach(match => {
    let stepIndex = parseInt(match.replace(reg, "$1"));
    let targetStep = step;

    for (let index = 0; index < stepIndex; index++) {
      targetStep =
        targetStep.outcomes[
          targetStep.result != null && targetStep.result.outcome != null
            ? targetStep.result.outcome
            : 0
        ];
    }

    let effect =
      targetStep != null &&
      targetStep.result != null &&
      targetStep.result.effect != null
        ? targetStep.result.effect
        : 0;

    calculation = calculation.replace(match, effect);
  });

  try {
    return Math.round(mexp.eval(calculation));
  } catch (e) {
    return 0;
  }
}

export function getAttributeValuesInResults(step, attributeName) {
  const attributeValues = mapCompleteSteps(step, function(step) {
    return step.result[attributeName] ? step.result[attributeName] : null;
  });

  return attributeValues.filter(function(el) {
    return el != null;
  });
}

export function getDeepestAttributeValueInResults(step, attributeName) {
  const deepestAttributeValue = getAttributeValuesInResults(
    step,
    attributeName
  );

  return deepestAttributeValue.length
    ? deepestAttributeValue[deepestAttributeValue.length - 1]
    : null;
}
